/* eslint max-classes-per-file: 0 */

import {
  KimVariant as Data,
  KimVariantCollection as Collection,
} from '@/typings/api/CollectorPublication'
import { BaseCollectorApiAuth } from '@/api/BaseApiAuth'
import { AxiosRequestConfig } from 'axios'

export class CollectorUploadApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = '/';

  protected readonly hasFinishSlash = false;

  constructor(
    protected readonly baseURL = process.env.VUE_APP_COLLECTOR_API_URL,
    protected readonly endpointPrefix = process.env.VUE_APP_COLLECTOR_UPLOAD_API_URL_PREFIX,
  ) {
    super(baseURL, endpointPrefix)
  }

  public upload(file: File, publication_id: string|number, task_key: string, config: AxiosRequestConfig = {}) {
    const path = 'upload_file'
    const [url] = this.getUrl(path)
    const data = new FormData()
    data.append('file', file)
    data.append('publication_id', publication_id.toString())
    data.append('task_key', task_key)

    return this.request('POST', url, { data, ...config })
  }

  public uploadVPRFile(
    file: File, pubId: number, pubPartId: number, taskKey: 'VPR_USERS' | 'VPR_VARIANTS_CRITERIA' | 'VPR_VARIANTS', config: AxiosRequestConfig = {},
  ) {
    const path = 'upload_file'
    const [url] = this.getUrl(path)
    const data = new FormData()
    data.append('file', file)
    data.append('publication_id', String(pubId))
    data.append('publication_part_id', String(pubPartId))
    data.append('task_key', taskKey)

    return this.request('POST', url, { data, ...config })
  }

  public uploadOCRFile(
    file: File,
    formDataId: string | number,
    lkPublicationId: string | number,
    formDataSize: string | number,
    dataCollectionId?: string | number,
    formTemplateId?: string | number,
    procedure_digit_code?: string,
    config: AxiosRequestConfig = {},
  ) {
    const path = 'upload_file_ocr'
    const [url] = this.getUrl(path)
    const data = new FormData()
    data.append('file', file)
    data.append('form_data_id', formDataId.toString())
    data.append('form_data_size', formDataSize.toString())
    data.append('lk_publication_id', lkPublicationId.toString())
    data.append('task_key', 'FSD_OCR_RECOGNITION')
    if (dataCollectionId) {
      data.append('data_collection_id', dataCollectionId.toString())
    }
    if (formTemplateId) {
      data.append('form_template_id', formTemplateId.toString())
    }
    if (procedure_digit_code) {
      data.append('procedure_digit_code', procedure_digit_code)
    }

    return this.request('POST', url, { data, ...config })
  }
}
